import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Admin JWT takes precedence for admin endpoints
  const adminToken = sessionStorage.getItem("hm_admin_token") || localStorage.getItem("hm_token");
  const url = String(config.url || "");
  const isAdminEndpoint = url.startsWith("/admin/") || url.startsWith("admin/") || url.includes("/admin/");
  if (adminToken && isAdminEndpoint) {
    config.headers.Authorization = `Bearer ${adminToken}`;
    return config;
  }
  if (adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
    return config;
  }
  // Optional customer session for public endpoints (e.g. /uploads)
  const custToken = sessionStorage.getItem("hm_customer_token");
  const custExp = Number(sessionStorage.getItem("hm_customer_token_exp") || 0);
  if (custToken && custExp > Date.now()) {
    config.headers.Authorization = `Bearer ${custToken}`;
  }
  return config;
});

export const setCustomerSession = (token, expiresInSeconds) => {
  sessionStorage.setItem("hm_customer_token", token);
  sessionStorage.setItem("hm_customer_token_exp", String(Date.now() + (expiresInSeconds - 30) * 1000));
};

export const ensureCustomerSession = async (email, phone) => {
  if (!email || !phone) return;
  const exp = Number(sessionStorage.getItem("hm_customer_token_exp") || 0);
  if (exp > Date.now() + 60_000) return;  // still valid > 1 min
  try {
    const { data } = await api.post("/customer/session", { email, phone });
    if (data?.token) setCustomerSession(data.token, data.expires_in_seconds || 1800);
  } catch { /* silent */ }
};

export const setAuth = (token, user) => {
  if (token) sessionStorage.setItem("hm_admin_token", token);
  localStorage.removeItem("hm_token");
  localStorage.setItem("hm_user", JSON.stringify(user));
};

export const clearAuth = () => {
  sessionStorage.removeItem("hm_admin_token");
  localStorage.removeItem("hm_token");
  localStorage.removeItem("hm_user");
};

export const getUser = () => {
  try {
    const u = localStorage.getItem("hm_user");
    return u ? JSON.parse(u) : null;
  } catch {
    return null;
  }
};

export const isAuthed = () => !!localStorage.getItem("hm_user");
